<template>
  <div class="tabs">
    <el-tag
      v-for="tag in tags"
      :key="tag.name"
      :closable="tag.name !== 'main'"
      :disable-transitions="false"
      @close="handleClose(tag)"
      @click="changeMenu(tag)"
      :effect="$route.name === tag.name ? 'dark' : 'plain'"
    >
      <span :class="`mui-icon iconfont ${tag.icon}`"></span>
      {{ tag.label }}
    </el-tag>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  computed: {
    ...mapState({
      tags: (state) => state.tab.tabList,
    }),
  },
  data() {
    return {
    };
  },
  created() {

  },
  methods: {
    ...mapMutations({
      close: "closeTab",
    }),
    handleClose(tag) {
      var index = this.tags[this.tags.indexOf(tag)];//当前菜单栏下标
      var index1 = this.tags.indexOf(tag)-1;//当前菜单栏前一个下标
      var index2 = this.tags.indexOf(tag)+1;//当前菜单栏后一个菜单的下标
      var path = "";
      var name = "";
      var label = "";
      if (this.tags[index2] !== undefined){
        label = this.tags[index2].label;
        name = this.tags[index2].name;
        path = this.tags[index2].path;
        this.tags.splice(this.tags.indexOf(tag),1);
        this.$router.replace(path);
      }else{
        path = this.tags[index1].path+"";
        name = this.tags[index1].name+"";
        label = this.tags[index1].label+"";
        if (path === "/"){
          this.$router.replace("/Home");
        }else{
          this.$router.push({ name: name })
        }
        this.close(this.tags.indexOf(tag))
      }
      if (path==="/"){
        this.$store.state.tab.currentMenu={
          path:"/",
          name:"main",
          label: "首页",
        }
      }else{
        this.$store.state.tab.currentMenu={
          label:label,
          path:path,
          name:name
        }
      }
      console.log(this.$store.state.tab.currentMenu)
    },
    changeMenu(item) {
      this.$router.push({
        name: item.name,
      });
      this.$store.commit("selectMenu", item);

    },
  },
};
</script>

<style lang="less" scoped>
.tabs {
  width: 99%;
  height: 30px;
  line-height: 30px !important;
  margin: 10px auto 0;
  z-index: 1;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.el-tag {
  height: 30px;
  line-height: 30px;
  margin-right: 6px;
  cursor: pointer;
  border-radius: 3px !important;
}
.tabs ::v-deep.el-tag--plain .el-tag__close {
    color: black !important;
}
.tabs ::v-deep.el-tag .el-icon-close {
  font-size: 16px !important;
  height: 16px !important;
  width: 16px !important;
  line-height: 16px;
}
//.tabs ::v-deep .el-tag .el-icon-close::before {
//  display: none !important;
//}
.tabs ::v-deep.el-tag--dark .el-tag__close:hover {
    color: #FFF !important;
    background-color: #DDDDDD !important;
}
.tabs ::v-deep.el-tag--plain .el-tag__close:hover {
    color: #FFF !important;
    background-color: #DDDDDD !important;
}
.tabs ::v-deep .el-tag--dark {
  background-color: #ffffff;
  border-color: #4e70ad;
  color: #4e70ad;
}
.tabs ::v-deep .el-tag--plain {
  background-color: #fff;
  border-color: #ffffff;
  color: #806d6d;
}
</style>
